import FacebookIconDark from 'assets/images/icons/dark - facebook.svg?react';
import FacebookIconSpringVibes from 'assets/images/icons/spring - facebook.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyFacebookIcon = (props: IIconProps) =>
  useTemplateVariant({
    dark: () => <BaseIcon icon={FacebookIconDark} {...props} />,
    springVibes: () => <BaseIcon icon={FacebookIconSpringVibes} {...props} />,
    _default_: () => <i className="fa fa-facebook" style={{ color: props.color }} />,

    classic: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    simpleFiligree: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    vickyBaumannBoho: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    vickyBaumannFineart: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    breeze: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    capri: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    rose: () => <i className="fa fa-facebook" style={{ color: props.color }} />,
    calm: () => <i className="fa fa-facebook" style={{ color: props.color }} />
  })();

export const FacebookIcon = (props: IIconProps) => (
  <SetIcon slug="facebook" fallback={LegacyFacebookIcon} {...props} />
);
